var React = require('react');

function InstructionIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 2c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm-1-13a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6zm1-5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z","fill":"#fff"}));
}

InstructionIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = InstructionIcon;

InstructionIcon.default = InstructionIcon;
